import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var switchComponentName = 'QuantumSwitch';
export function getSwitchUtilityClass(slot) {
    return generateUtilityClass(switchComponentName, slot);
}
export var switchClasses = generateUtilityClasses(switchComponentName, ['switch', 'formControlLabel']);
